import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { HinweiseProvider } from './components/Hinweise';
import PrivateRoute from './components/PrivateRoute';
import TrainerRoute from './components/TrainerRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Warteliste from './pages/Warteliste';
import Kontaktanfragen from './pages/Kontaktanfragen';
import Probetraining from './pages/Probetraining';
import Benutzer from './pages/Benutzer';
import Einstellungen from './pages/Einstellungen';
import Kacheln from './pages/Kacheln';
import KachelForm from './pages/KachelForm';
import Angebote from './pages/Angebote';
import AngebotForm from './pages/AngebotForm';
import AngebotDetail from './pages/AngebotDetail';
import AngebotTypen from './pages/AngebotTypen';
import EmailVorlagen from './pages/EmailVorlagen';
import EmailVorlagenForm from './pages/EmailVorlagenForm';
import EmailArchiv from './pages/EmailArchiv';
import Gruppen from './pages/Gruppen';
import GruppenForm from './pages/GruppenForm';
import GruppenDetail from './pages/GruppenDetail';
import Schwimmer from './pages/Schwimmer';
import SchwimmerDetail from './pages/SchwimmerDetail';
import Statistik from './pages/Statistik';
import Uebungen from './pages/Uebungen';
import Bilder from './pages/Bilder';
import TrainerGruppen from './pages/trainer/TrainerGruppen';
import TrainerGruppe from './pages/trainer/TrainerGruppe';
import TrainerEinheit from './pages/trainer/TrainerEinheit';
import TrainerSchwimmer from './pages/trainer/TrainerSchwimmer';
import TrainerStunden from './pages/trainer/TrainerStunden';
import Team from './pages/Team';
import Rollen from './pages/Rollen';
import Stunden from './pages/Stunden';
import Leistungsgruppen from './pages/Leistungsgruppen';
import Bahnen from './pages/Bahnen';

export default function App() {
  return (
    <AuthProvider>
     <HinweiseProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Trainer-Oberfläche (mobile-optimiert, kein Sidebar-Layout) */}
          <Route path="/trainer" element={<TrainerRoute><Navigate to="/trainer/gruppen" replace /></TrainerRoute>} />
          <Route path="/trainer/gruppen" element={<TrainerRoute><TrainerGruppen /></TrainerRoute>} />
          <Route path="/trainer/gruppen/:id" element={<TrainerRoute><TrainerGruppe /></TrainerRoute>} />
          <Route path="/trainer/einheiten/:id" element={<TrainerRoute><TrainerEinheit /></TrainerRoute>} />
          <Route path="/trainer/schwimmer/:id" element={<TrainerRoute><TrainerSchwimmer /></TrainerRoute>} />
          <Route path="/trainer/stunden" element={<TrainerRoute><TrainerStunden /></TrainerRoute>} />

          {/* Admin-Oberfläche */}
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/warteliste" element={<PrivateRoute><Warteliste /></PrivateRoute>} />
          <Route path="/kontakt" element={<PrivateRoute><Kontaktanfragen /></PrivateRoute>} />
          <Route path="/probetraining" element={<PrivateRoute><Probetraining /></PrivateRoute>} />
          <Route path="/benutzer" element={<PrivateRoute><Benutzer /></PrivateRoute>} />
          <Route path="/kacheln" element={<PrivateRoute><Kacheln /></PrivateRoute>} />
          <Route path="/kacheln/neu" element={<PrivateRoute><KachelForm /></PrivateRoute>} />
          <Route path="/kacheln/:id/bearbeiten" element={<PrivateRoute><KachelForm /></PrivateRoute>} />
          <Route path="/einstellungen" element={<PrivateRoute><Einstellungen /></PrivateRoute>} />
          <Route path="/angebote" element={<PrivateRoute><Angebote /></PrivateRoute>} />
          <Route path="/angebote/neu" element={<PrivateRoute><AngebotForm /></PrivateRoute>} />
          <Route path="/angebote/:id" element={<PrivateRoute><AngebotDetail /></PrivateRoute>} />
          <Route path="/angebote/:id/bearbeiten" element={<PrivateRoute><AngebotForm /></PrivateRoute>} />
          <Route path="/angebot-typen" element={<PrivateRoute><AngebotTypen /></PrivateRoute>} />
          <Route path="/email-vorlagen" element={<PrivateRoute><EmailVorlagen /></PrivateRoute>} />
          <Route path="/email-vorlagen/neu" element={<PrivateRoute><EmailVorlagenForm /></PrivateRoute>} />
          <Route path="/email-vorlagen/:id" element={<PrivateRoute><EmailVorlagenForm /></PrivateRoute>} />
          <Route path="/email-archiv" element={<PrivateRoute><EmailArchiv /></PrivateRoute>} />
          <Route path="/gruppen" element={<PrivateRoute><Gruppen /></PrivateRoute>} />
          <Route path="/gruppen/neu" element={<PrivateRoute><GruppenForm /></PrivateRoute>} />
          <Route path="/gruppen/:id" element={<PrivateRoute><GruppenDetail /></PrivateRoute>} />
          <Route path="/gruppen/:id/bearbeiten" element={<PrivateRoute><GruppenForm /></PrivateRoute>} />
          <Route path="/schwimmer" element={<PrivateRoute><Schwimmer /></PrivateRoute>} />
          <Route path="/schwimmer/:id" element={<PrivateRoute><SchwimmerDetail /></PrivateRoute>} />
          <Route path="/statistik" element={<PrivateRoute><Statistik /></PrivateRoute>} />
          <Route path="/uebungen" element={<PrivateRoute><Uebungen /></PrivateRoute>} />
          <Route path="/bilder" element={<PrivateRoute><Bilder /></PrivateRoute>} />
          <Route path="/team" element={<PrivateRoute><Team /></PrivateRoute>} />
          <Route path="/rollen" element={<PrivateRoute><Rollen /></PrivateRoute>} />
          <Route path="/stunden" element={<PrivateRoute><Stunden /></PrivateRoute>} />
          <Route path="/leistungsgruppen" element={<PrivateRoute><Leistungsgruppen /></PrivateRoute>} />
          <Route path="/bahnen" element={<PrivateRoute><Bahnen /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
     </HinweiseProvider>
    </AuthProvider>
  );
}
